var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// Components
import { SplitButtonStructure } from '../components/SplitButtonStructure';
// Styles
import { Button } from '../../Button';
import { IconButton } from '../../IconButton';
import { getSplitButtonStylesByVariant } from './getSplitButtonStylesByVariant';
// Utils
import styled from 'styled-components';
import { getSplitButtonStylesByVariantAndSize } from './getSplitButtonStylesByVariantAndSize';
/**
 * @deprecated This will be replaced with SplitButtonWithDropdown in the next major version
 */
export var StyledSplitButton = styled(SplitButtonStructure)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", ";\n\n  box-sizing: border-box;\n\n  ", ":first-child {\n    border-top-right-radius: 0px;\n    border-bottom-right-radius: 0px;\n  }\n\n  ", ":last-child {\n    border-top-left-radius: 0px;\n    border-bottom-left-radius: 0px;\n  }\n"], ["\n  ", "\n  ", ";\n\n  box-sizing: border-box;\n\n  ", ":first-child {\n    border-top-right-radius: 0px;\n    border-bottom-right-radius: 0px;\n  }\n\n  ", ":last-child {\n    border-top-left-radius: 0px;\n    border-bottom-left-radius: 0px;\n  }\n"])), function (_a) {
    var disabled = _a.disabled, styleVariant = _a.styleVariant, theme = _a.theme;
    return getSplitButtonStylesByVariant(disabled, styleVariant, theme);
}, function (_a) {
    var styleVariant = _a.styleVariant, size = _a.size;
    return getSplitButtonStylesByVariantAndSize(styleVariant, size);
}, Button, IconButton);
var templateObject_1;
//# sourceMappingURL=StyledSplitButton.js.map